/**
 * In-memory cache for /spikex-card page state.
 * Survives route remounts within the same browser session so returning from
 * recharge/transactions can render the last known card view immediately.
 */

let store = {
  userKey: null,
  snapshot: null,
};

export function getSpikexCardPageCacheUserKey(userInfo) {
  const id = userInfo?.userId;
  if (id == null || id === "") return null;
  return String(id);
}

export function readSpikexCardPageCache(userKey) {
  if (!userKey || store.userKey !== userKey || !store.snapshot) return null;
  return store.snapshot;
}

export function writeSpikexCardPageCache(userKey, partial) {
  if (!userKey) return;
  if (store.userKey !== userKey) {
    store = { userKey, snapshot: {} };
  }
  store.snapshot = {
    ...store.snapshot,
    ...partial,
    updatedAt: Date.now(),
  };
}

export function clearSpikexCardPageCache(userKey) {
  if (!userKey || store.userKey === userKey) {
    store = { userKey: null, snapshot: null };
  }
}
